import { fetchOfferView } from '../../../services/chatbotFeedback/fetchOfferView';
import { TThunkAction } from '../../../types/redux/thunk';

export const setViewOffer =
  (offerId: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    await fetchOfferView(context, offerId);
  };
